import { ReceptforskrivningMall } from "@/store/modules/recept/receptforskrivningMallModule";

export const getMalltypLabel = ({
    mall,
    currentProfileId,
}: {
    mall: ReceptforskrivningMall;
    currentProfileId?: string;
}) => {
    if (mall.typ !== "PRIVAT") {
        return "Gemensam";
    }

    return mall.created_by === currentProfileId ? "Min mall" : "Annans mall";
};
